export default "__VITE_ASSET__2c7c2c5c__"